export function Tooltip({text}) {
  return (
    <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 
        hidden group-hover:block bg-indigo-400 text-white text-xs rounded px-2 py-1 z-50 whitespace-nowrap shadow-md">
      {text}
    </div>
  );
}